import { Routes, Route, useLocation, useParams } from "react-router-dom";

import ProfileForm from "../../components/DashBoard/ProfileForm";
import CompanyHeader from "../../components/DashBoard/CompanyHeader";
import HeaderTabs from "../../components/DashBoard/HeaderTabs";
import styles from "./CompanyProfile.module.css";
import { Delay, Loader, Logger, ObjectNotEmpty } from "../../Utils/helper";
import { useSelector } from "react-redux";
import useRefreshToken from "../../Hooks/usegenerateToken";
import Document from "./Document";
import { useState, useEffect } from "react";
import { BASE_URL, USER_TOKEN, GET_VERIFIER, GET_ISSUER, USER_TYPES } from "../../Utils/constant";
import { Breadcrumb } from "../../Utils/helper";
import Error from "../../components/OnBoard/Error"
import VerifierFields from "./VerifierInternalDashboard/VerifierFields";
import VerifierForms from "./VerifierInternalDashboard/VerifierForms";
import API from "../../ApiConfig";
import cogoToast from "cogo-toast-react-17-fix";
import LoaderComp from "../../components/Loader";
import SlideUpWrapper from "../../components/Transitions/SlideUpWrapper";
import CreateForm from "./ExternalDash/Verifier/RequestVerifications/CreateVeriferForm";
import FormType from "./ExternalDash/Verifier/RequestVerifications/FormType";
import SelectForm from "./ExternalDash/Verifier/RequestVerifications/SelectForm";
import RecipientsDetails from "./ExternalDash/Verifier/RequestVerifications/recipientsDetails";
import BulkRecipients from "./ExternalDash/Verifier/RequestVerifications/BulkRecipients";
import MyRequests from "./ExternalDash/Verifier/RequestVerifications/MyRequests";
import RequestDetails from "./ExternalDash/Verifier/RequestVerifications/RequestDetails";
import FormDetails from "./ExternalDash/Verifier/FormDetails";
import DocumentType from "./DocumentType";
import Documents from "./Document";
import Credentials from "./ExternalDash/Credentials";
import IssueCredentials from "./ExternalDash/IssueCredentials";
import DocumentDiscrepencyDetails from "./ExternalDash/Issuer/DocumentDiscrepencyDetails";
import IssueDocumentDetails from "./ExternalDash/IssueDocumentDetails";


const CompanyProfile = () => {
  let { id, user_type } = useParams();
  const [companyProfile, setcompanyProfile] = useState({})
  const [headerPos, setHeaderPos] = useState(0)
  const [loading, setLoading] = useState(false)
  const location = useLocation()
  const User=useSelector(state=>state.User)
  
  const Tabs = {
    1: [
      { name: "Profile", link: `/company/${user_type}/${id}/profile`, img: "/profilecardoutline.svg", img1: "/profilecardoutline1.svg" },
      { name: "Document", link: `/company/${user_type}/${id}/Documents`, img: "/copyoutline.svg", img1: "/copyoutline-1.svg" },
    ],
    2: [
      { name: "Profile", link: `/company/${user_type}/${id}/profile`, img: "/profilecardoutline.svg", img1: "/profilecardoutline1.svg" },
      { name: "My Forms", link: `/company/${user_type}/${id}/verifier-forms`, img: "/copyoutline.svg", img1: "/copyoutline-1.svg" },
    ]

  }

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!ObjectNotEmpty(companyProfile)) {
      getProfileDetails()
    }
  }, [])
  useEffect(() => {
    if (Tabs[user_type]) {
      let pos = Tabs[user_type].findIndex(item => item.link === location.pathname)
      setHeaderPos(pos)
    }
    else {
      setHeaderPos(0)
    }
  }, [location.pathname])
  async function getProfileDetails() {
    let URL = user_type == '2' ? GET_VERIFIER + id : GET_ISSUER + id
    setLoading(true)
    await Delay()
    API.get(URL)
      .then(res => {
        setLoading(false)
        if (res.data.status === 200) {
          setcompanyProfile(res.data.data);
        }
      }).catch(err => {
        setLoading(false)
        setcompanyProfile(0)
        cogoToast.error("Something is not right!")
      });
  }

  const CompanyHeaderComponent = () => {
    if (!ObjectNotEmpty(companyProfile)) {
      return (
        <div className={styles.companyHeader}>
          <CompanyHeader user_type={user} />
          <HeaderTabs Tabs={Tabs[user_type]} position={headerPos} id={id} />
        </div>
      )
    }
    else {
      return (
        <div className={styles.companyHeader}>
          <CompanyHeader companyProfile={companyProfile} user_type={user} />
          <HeaderTabs Tabs={Tabs[user_type]} position={headerPos} id={id} />
        </div>
      )
    }
  }

  Logger("companyProfile")
  // console.log(companyProfile)
  let user = user_type == '2' ? "Verifier" : "Issuer"
  if (companyProfile === 0) {
    let user = user_type == '2' ? "Verifier" : "Issuer"
    return (
      <Error Message={`${user} is not Onboarded`} subMessage="please contact issuer or admin for more information" />
    )
  }
  return (
    <SlideUpWrapper direction="slide-left">
      <div className={styles.companyProfile}>
        {/* <Breadcrumb paths={[{ name: companyProfile.name, url: `/company/${user_type}/${id}/profile`}]} /> */}
        {id == 2 || User.user_type=="Super Admin" ?
          <div style={{paddingTop:"5rem"}}></div> :
          <CompanyHeaderComponent />
        }
        <main className={styles.frameSupportingText}>
          <section className={styles.h1Parent}>
            <Routes>
              <Route path="/profile" element={<ProfileForm companyProfile={companyProfile} />} />
              <Route path="/credentials" element={<Credentials ISSUER_ID={id}/>}/>
              <Route path='/credentials/issue-credentials' element={<IssueCredentials ISSUER_ID={id} />} />

              <Route path="/documentDetails/:issued_uuid" element={<IssueDocumentDetails/>}/>



              <Route path="/doc_descrepency_details/:appeal_id" element={<DocumentDiscrepencyDetails/>}/>
              
              <Route path="/Documents" element={<Document id={id} />} />
              <Route path="/verification-fields" element={<VerifierFields isEdit={false} id={id} />} />
              <Route path="/verifier-forms" element={<VerifierForms id={id} />} />
              <Route path="/verification-fields/:uuid" element={<VerifierFields isEdit={true} id={id} />} />
              <Route path="/forms/createForm" element={<CreateForm />} />
              <Route path="/forms/formType" element={<FormType />} />
              <Route path="/forms/selectForms" element={<SelectForm id={id} />} />
              <Route path='/forms/:form_id' element={<FormDetails />} />
              <Route path="/forms/RecipientsDetails" element={<RecipientsDetails id={id} />} />
              <Route path="/forms/BulkRecipients" element={<BulkRecipients />} />
              <Route path="/forms/myRequests/" element={<MyRequests id={id} />} />
              <Route path="/forms/requestDetails/:request_id" element={<RequestDetails />} />

              <Route path="/newDocument" element={<DocumentType id={id} />} />
              <Route path="/newForm" element={<FormType />} />


            </Routes>
          </section>
        </main>
      </div>
    </SlideUpWrapper>
  );
};

export default CompanyProfile;